export const config = {
  MODE: process.env.MODE,
  BASE_ROUTE_PATH: process.env.VITE_BASE_PATH || '',

  API_URL: process.env.VITE_API_URL,
  WS_URL: process.env.VITE_WS_URL,

  BUILD_DATE: process.env.__BUILD_DATE__,
  BUILD_REF: process.env.__BUILD_REF__,

  INTERCOM_APPID: process.env.VITE_INTERCOM_APPID,

  SENTRY_URL: process.env.VITE_SENTRY_URL,

  ANALYTICS_CODE: process.env.VITE_ANALYTICS_CODE || '',

  FORMS_URL: process.env.VITE_FORMS_URL || 'http://localhost:3005',

  PORTAL_URL: process.env.VITE_PORTAL_URL || 'http://localhost:3007',

  // Seasonal sign-in scene, shown 1 Oct – 1 Nov. Set to 'off' to disable it.
  HALLOWEEN_SIGNIN: process.env.VITE_HALLOWEEN_SIGNIN,
} as const;
